/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChatbotSettings } from '../models/ChatbotSettings';
import type { CreateChatbotSessionResponse } from '../models/CreateChatbotSessionResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ChatbotService {
    /**
     * Creates a new unauthenticated chatbot session
     * @returns CreateChatbotSessionResponse successful response
     * @throws ApiError
     */
    public static crateUnauthenticatedChatbotSession(): CancelablePromise<CreateChatbotSessionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chatbot/sessions/actions/createUnauthenticatedSession',
            errors: {
                400: `some error occurred during processing`,
            },
        });
    }
    /**
     * Creates a new authenticated chatbot session
     * @returns CreateChatbotSessionResponse successful response
     * @throws ApiError
     */
    public static crateAuthenticatedChatbotSession(): CancelablePromise<CreateChatbotSessionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chatbot/sessions/actions/createAuthenticatedSession',
            errors: {
                400: `some error occurred during processing`,
                500: `internal server error`,
            },
        });
    }
    /**
     * Gets chatbot settings
     * @returns ChatbotSettings successful response
     * @throws ApiError
     */
    public static getChatbotSettings(): CancelablePromise<ChatbotSettings> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/chatbot/settings',
            errors: {
                400: `some error occurred during processing`,
            },
        });
    }
}
